import React from 'react';
import { Box, Typography } from '@mui/material';
import { vortxTypography } from '@vortx/shared-ui';

const PlatformStatusBar = ({
    totalProjects = 0,
    totalEnergyMwh = 0,
    totalOptimizations = 0,
    systemsOnline = 5
}) => {
    return (
        <Box sx={{
            width: '100%',
            height: { xs: '60px', sm: '70px', md: '80px' },
            background: '#0a1210',
            border: '1px solid #5fd4c4',
            borderRadius: '4px',
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            fontFamily: vortxTypography.mono,
            position: 'relative',
            // Scan lines effect
            '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'repeating-linear-gradient(0deg, rgba(0,0,0,0.1) 0px, rgba(0,0,0,0.1) 1px, transparent 1px, transparent 3px)',
                pointerEvents: 'none',
            },
        }}>
            {/* Top row: Branding and status */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative', zIndex: 1 }}>
                <Typography sx={{
                    color: '#5fd4c4',
                    fontSize: { xs: '0.75rem', sm: '0.85rem', md: '0.9rem' },
                    fontWeight: 600,
                    letterSpacing: '0.1em',
                    textShadow: '0 0 10px #5fd4c4',
                }}>
                    VORTX FLUX PLATFORM
                </Typography>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {/* System status indicators */}
                    {[...Array(systemsOnline)].map((_, i) => (
                        <Box
                            key={i}
                            sx={{
                                width: '8px',
                                height: '8px',
                                borderRadius: '50%',
                                background: '#4ade80',
                                boxShadow: '0 0 8px #4ade80',
                            }}
                        />
                    ))}
                    <Typography sx={{
                        color: '#4ade80',
                        fontSize: { xs: '0.65rem', sm: '0.75rem' },
                        fontWeight: 600,
                        ml: 0.5,
                    }}>
                        ONLINE
                    </Typography>
                </Box>
            </Box>

            {/* Bottom row: Metrics */}
            <Box sx={{ display: 'flex', gap: { xs: 1, sm: 2 }, alignItems: 'center', position: 'relative', zIndex: 1 }}>
                <Typography sx={{
                    color: '#c8c8c8',
                    fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.85rem' },
                }}>
                    {totalProjects} PROJECTS
                </Typography>
                <Typography sx={{ color: '#666' }}>|</Typography>
                <Typography sx={{
                    color: '#c8c8c8',
                    fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.85rem' },
                }}>
                    {totalEnergyMwh.toFixed(1)} MWH
                </Typography>
                <Typography sx={{ color: '#666' }}>|</Typography>
                <Typography sx={{
                    color: '#c8c8c8',
                    fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.85rem' },
                }}>
                    {totalOptimizations} OPTIMIZATIONS
                </Typography>
            </Box>
        </Box>
    );
};

export default PlatformStatusBar;
